
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CareersPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1120] flex flex-col">
      {/* Navbar */}
      <nav className="w-full py-6 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <span className="text-[8px] sm:text-lg font-bold text-white whitespace-nowrap" style={{ WebkitTextStroke: '0.5px black', paintOrder: 'stroke fill' }}>
              <span className="text-red-600">P</span>ATRIOT DEFENSE <span className="text-[#0066CC]">T</span>ECHNOLOGIES
            </span>
          </Link>
          <Link
            to="/"
            className="px-5 py-2 border border-white/20 text-white rounded-lg text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Coming Soon Content */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-8 rounded-2xl bg-[#0066CC]/10 border border-[#0066CC]/20 flex items-center justify-center">
            <i className="ri-briefcase-line text-4xl text-[#0066CC]"></i>
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0066CC]/10 border border-[#0066CC]/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-[#0066CC] animate-pulse"></span>
            <span className="text-[#0066CC] text-xs font-semibold uppercase tracking-wider whitespace-nowrap">Coming Soon</span>
          </div>

          <h1 className="text-3xl sm:text-5xl font-bold text-white mb-4 leading-tight">
            We&apos;re Building Something <span className="text-[#0066CC]">Great</span>
          </h1>
          <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-10 max-w-lg mx-auto">
            Our careers page is under construction. We&apos;re always looking for talented individuals who are passionate about defense technology and innovation. Check back soon for open positions.
          </p>

          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-[#0066CC]/10 flex items-center justify-center">
                <i className="ri-rocket-line text-lg text-[#0066CC]"></i>
              </div>
              <h3 className="text-white text-sm font-semibold mb-1">Innovation</h3>
              <p className="text-gray-500 text-xs">Work on cutting-edge defense technology solutions</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-[#0066CC]/10 flex items-center justify-center">
                <i className="ri-team-line text-lg text-[#0066CC]"></i>
              </div>
              <h3 className="text-white text-sm font-semibold mb-1">Team Culture</h3>
              <p className="text-gray-500 text-xs">Join a collaborative and mission-driven team</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-5">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-[#0066CC]/10 flex items-center justify-center">
                <i className="ri-line-chart-line text-lg text-[#0066CC]"></i>
              </div>
              <h3 className="text-white text-sm font-semibold mb-1">Growth</h3>
              <p className="text-gray-500 text-xs">Advance your career with continuous learning</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 bg-[#0066CC] text-white rounded-lg font-semibold text-sm hover:bg-[#0055AA] transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Our Services
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 border border-white/20 text-white rounded-lg font-semibold text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              Learn About Us
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 sm:px-6 border-t border-white/10">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">© 2026 Patriot Defense Technologies LLC. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="text-xs text-gray-500 hover:text-gray-300 transition-colors whitespace-nowrap cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
